var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"root",staticClass:"HintWrapper",on:{"mouseenter":function($event){return _vm.showPopup()},"mouseleave":function($event){return _vm.hidePopup()}}},[(_vm.showInfoSign)?_c('span',{staticClass:"HintWrapperInfo"},[_vm._v("i")]):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }